export default "__VITE_ASSET__5H0EnXAL__"